import { useSearchParams } from "react-router-dom";
import { useApi } from "@/lib/useApi";
import { ProductGrid } from "@/components/ProductCard";
import { Loading } from "@/components/RequireAuth";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const cat = params.get("categorie") || "";
  const sort = params.get("tri") || "pertinence";
  const page = Number(params.get("page") || 1);
  const qs = new URLSearchParams({ ...(q && { q }), ...(cat && { category: cat }), sort, page, limit: 20 }).toString();
  const { data } = useApi(`/products?${qs}`);
  const { data: cats } = useApi("/categories");
  const set = (k, v) => {
    const n = new URLSearchParams(params);
    v ? n.set(k, v) : n.delete(k);
    if (k !== "page") n.delete("page");
    setParams(n);
  };
  const catName = cats?.find((c) => c.slug === cat)?.name;
  const pages = data ? Math.ceil(data.total / data.limit) : 1;

  return (
    <div data-testid="catalog-page" className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <h1 className="font-display text-3xl font-black tracking-tight md:text-4xl">
        {q ? `Résultats pour « ${q} »` : catName || "Tous les produits"}
      </h1>
      <div className="no-scrollbar mt-5 flex items-center gap-2 overflow-x-auto pb-2">
        <button data-testid="filter-cat-all" onClick={() => set("categorie", "")} className={`shrink-0 rounded-full px-4 py-1.5 text-sm font-semibold ${!cat ? "bg-gray-900 text-white" : "bg-white ring-1 ring-gray-200"}`}>Tout</button>
        {cats?.map((c) => (
          <button key={c.slug} data-testid={`filter-cat-${c.slug}`} onClick={() => set("categorie", c.slug)} className={`shrink-0 rounded-full px-4 py-1.5 text-sm font-semibold ${cat === c.slug ? "bg-gray-900 text-white" : "bg-white ring-1 ring-gray-200"}`}>{c.name}</button>
        ))}
      </div>
      <div className="mb-5 mt-3 flex items-center justify-between">
        <p data-testid="catalog-total" className="text-sm text-gray-500">{data ? `${data.total} produit(s)` : ""}</p>
        <Select value={sort} onValueChange={(v) => set("tri", v)}>
          <SelectTrigger data-testid="sort-select" className="w-48"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="pertinence">Pertinence</SelectItem>
            <SelectItem value="recent">Plus récents</SelectItem>
            <SelectItem value="prix_asc">Prix croissant</SelectItem>
            <SelectItem value="prix_desc">Prix décroissant</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {!data ? <Loading /> : data.items.length === 0 ? (
        <p data-testid="catalog-empty" className="rounded-xl border border-dashed p-10 text-center text-gray-500">Aucun produit trouvé.</p>
      ) : <ProductGrid items={data.items} />}
      {pages > 1 && (
        <div className="mt-8 flex justify-center gap-2">
          <Button variant="outline" disabled={page <= 1} onClick={() => set("page", page - 1)} data-testid="page-prev">Précédent</Button>
          <span className="self-center text-sm">{page} / {pages}</span>
          <Button variant="outline" disabled={page >= pages} onClick={() => set("page", page + 1)} data-testid="page-next">Suivant</Button>
        </div>
      )}
    </div>
  );
}
